import { useState } from 'react'
import { useCreateCertification, useCertifications, useDeleteCertification } from '@/hooks/useCertifications'
import { useCategories } from '@/hooks/useServices'
import Button from '@/components/common/Button/Button'
import Input from '@/components/forms/Input/Input'
import Select from '@/components/forms/Select/Select'
import './ProviderAddCertification.css'

const ProviderAddCertification = () => {
    const { data: categories } = useCategories()
    const { data: certs, isLoading } = useCertifications()
    const create = useCreateCertification()
    const del = useDeleteCertification()

    const [service, setService] = useState('')
    const [name, setName] = useState('')
    const [number, setNumber] = useState('')
    const [org, setOrg] = useState('')
    const [issue, setIssue] = useState('')
    const [expiry, setExpiry] = useState('')
    const [url, setUrl] = useState('')

    const handleAdd = async () => {
        if (!service || !name || !org || !issue || !url) return
        await create.mutateAsync({
            service: Number(service),
            certificate_name: name,
            certificate_number: number || undefined,
            issuing_organization: org,
            issue_date: issue,
            expiry_date: expiry || undefined,
            certificate_url: url,
        })
        setService(''); setName(''); setNumber(''); setOrg(''); setIssue(''); setExpiry(''); setUrl('')
    }

    return (
        <div className="provider-add-certification-page">
            <div className="provider-add-certification-container">
                <h1 className="provider-add-certification-title">Agregar Certificación</h1>
                <Select label="Servicio" value={service} onChange={(e) => setService(e.target.value)} options={(categories || []).map((c: any) => ({ value: c.id, label: c.name }))} placeholder="Selecciona servicio" />
                <Input name="name" placeholder="Nombre" value={name} setValue={setName} effect3d={false} />
                <Input name="number" placeholder="Número (opcional)" value={number} setValue={setNumber} effect3d={false} />
                <Input name="org" placeholder="Organización" value={org} setValue={setOrg} effect3d={false} />
                <input type="date" className="provider-add-certification-date-input" placeholder="Fecha emisión" value={issue} onChange={(e) => setIssue(e.target.value)} />
                <input type="date" className="provider-add-certification-date-input" placeholder="Fecha venc. (opcional)" value={expiry} onChange={(e) => setExpiry(e.target.value)} />
                <Input name="url" placeholder="URL Certificado" value={url} setValue={setUrl} effect3d={false} />
                <Button variant="primary" onClick={handleAdd} disabled={create.isPending || !service || !name || !org || !issue || !url} effect3d={false}>Agregar</Button>

            <h2>My Certifications</h2>
            {isLoading ? (
                <div>Loading...</div>
            ) : (
                <div className="provider-certifications_list">
                    {(certs || []).map((c: any) => (
                        <div key={c.id} className="provider-certifications_item">
                            <div>{c.certificate_name}</div>
                            <div>{c.service_name}</div>
                            <Button variant="danger" size="sm" disabled={del.isPending} onClick={() => del.mutate(c.id)} effect3d={false}>Eliminar</Button>
                        </div>
                    ))}
                </div>
            )}
            </div>
        </div>
    )
}

export default ProviderAddCertification


